import { Box, styled } from "@mui/material";

export const PopoverContent = styled(Box)(({ theme: { palette, spacing } }) => ({
  background: palette.main[800],
  color: palette.common.white,

  "& .MuiInputBase-root": {
    "& .MuiSvgIcon-root": {
      color: palette.common.white,
    },
    "& input": {
      color: palette.common.white,
    },
    "& fieldset": {
      borderColor: palette.common.white,
      "&:hover": {
        borderColor: palette.common.white,
      },
    },
  },

  "& .MuiTypography-subtitle2": {
    margin: spacing(2),
    marginBottom: spacing(1),
    color: palette.main[100],
    textTransform: "uppercase",
    fontSize: 12,
  },

  "& .MuiButton-root": {
    justifyContent: "space-between",
    borderRadius: 0,
    background: "none",
    "&:hover": {
      background: palette.main[100],
      color: palette.main[900],
    },
  },

  "& .MuiDivider-root": {
    margin: spacing(2),
    borderColor: palette.main[600],
  },
}));
